  // Helper function to convert 24-hour time (HH:mm) to 12-hour AM/PM format
export  const convertTo12Hour = (time24) => {
    if (!time24) return '';
    // If already in 12-hour format (contains AM/PM), return as is
    if (time24.includes('AM') || time24.includes('PM') || time24.includes('am') || time24.includes('pm')) {
      return time24.trim();
    }
    // Convert from 24-hour format
    const [hours, minutes] = time24.split(':');
    const hour = parseInt(hours, 10);
    if (isNaN(hour)) return '';
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${String(hour12).padStart(2, '0')}:${minutes || '00'} ${ampm}`;
  };

  // Helper function to convert 12-hour AM/PM format to 24-hour format (HH:mm)
 export const convertTo24Hour = (time12) => {
    if (!time12) return '';
    // If already in 24-hour format (no AM/PM), return as is
    if (!time12.includes('AM') && !time12.includes('PM') && !time12.includes('am') && !time12.includes('pm')) {
      return time12.trim();
    }
    // Convert from 12-hour format
    const match = time12.trim().match(/(\d{1,2}):(\d{2})\s*(AM|PM|am|pm)/);
    if (!match) return '';
    let hour = parseInt(match[1], 10);
    const minutes = match[2];
    const ampm = match[3].toUpperCase();
    
    if (ampm === 'PM' && hour !== 12) {
      hour += 12;
    } else if (ampm === 'AM' && hour === 12) {
      hour = 0;
    }
    
    return `${String(hour).padStart(2, '0')}:${minutes}`;
  };
  
 export const convertDateFormat = (dateStr) => {
    if (!dateStr) return '';
    // If already in YYYY-MM-DD format, return as is
    if (dateStr.match(/^\d{4}-\d{2}-\d{2}/)) {
      return dateStr.split('T')[0]; // Remove time part if present
    }
    // If in DD-MM-YYYY format, convert to YYYY-MM-DD
    if (dateStr.match(/^\d{2}-\d{2}-\d{4}/)) {
      const [day, month, year] = dateStr.split('-');
      return `${year}-${month}-${day}`;
    }
    // If in DD/MM/YYYY format, convert to YYYY-MM-DD
    if (dateStr.match(/^\d{2}\/\d{2}\/\d{4}/)) {
      const [day, month, year] = dateStr.split('/');
      return `${year}-${month}-${day}`;
    }
    // If in ISO format, extract date part
    if (dateStr.includes('T')) {
      return dateStr.split('T')[0];
    }
    return dateStr;
  };